const explicitBase = (
  import.meta.env.VITE_API_URL as string | undefined
)?.replace(/\/$/, "");
const base = explicitBase || "";
let csrfToken = "";

export function setCsrf(value?: string) {
  csrfToken = value || "";
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData))
    headers.set("content-type", "application/json");
  if (csrfToken && !["GET", "HEAD"].includes(options.method || "GET"))
    headers.set("x-csrf-token", csrfToken);
  const response = await fetch(`${base}/api${path}`, {
    ...options,
    headers,
    credentials: "include",
  });
  const data = (await response.json().catch(() => ({}))) as { error?: string };
  if (!response.ok)
    throw new ApiError(
      data.error || `Request failed (${response.status})`,
      response.status,
    );
  return data as T;
}

export const json = (value: unknown) => JSON.stringify(value);
